<div class="ap-loader-modal">
    @if (modalOptions.options) {
        <ap-spinner
            [state]="state()"
            [loadingText]="modalOptions.options.loadingText"
            [readyText]="modalOptions.options.readyText"
        ></ap-spinner>
    }
</div>
